'use client';

import { ProjectModel } from "@/lib/models/Project";
import { RouterName } from "@/lib/enum/RouterEnum";
import { useIsSafari } from '@/lib/hooks/useIsSafari';
import { useContentSize } from "@/components/SizeProvider";
import { clearNavState, setNavState } from "@/lib/utils/navState";
import { PAGE_MOBILE } from "@/lib/constants";
import Link from "next/link";

interface Props {
  listProject: ProjectModel[];
  idActive: number;
}

const ListProject = (props: Props) => {
  const { listProject, idActive } = props;
  const isSafari = useIsSafari();
  const classNameText = isSafari ? 'text-gray-safari' : 'text-gray';
  const { width: widthContent } = useContentSize();

  const _computeProjectPath = (project: ProjectModel) => {
    let charExits = /\W/g;
    return `${RouterName.projectDetail}/${project.title.replaceAll(" ", "_").replace(charExits, '')}`
  };

  return (
    <div className={'header-right-box'}>
      <p className={classNameText}>{"\\\\MENU\\\\"}</p>
      <Link
        href={RouterName.dashboard}
        onClick={clearNavState}
        className='text-title-experiments'
        style={{
          fontSize: widthContent / 160,
        }}
      >
        <h2>EXPERIMENTS <span className="number-project">[VIEW ALL]</span></h2>
      </Link>
      <ol className={'list-project-name'}>
        {listProject.map((item, index: number) => {
          return (
            <li
              className={`text-title-project ${idActive === item.id ? 'text-title-project-active' : ''}`}
              key={item.id}
            >
              <Link
                href={_computeProjectPath(item)}
                onClick={() => setNavState(index + PAGE_MOBILE.PROJECTS)}
                prefetch={false}
              >
                {`${(index + 1).toString().padStart(2, '0')}`}\{item.detailTitle.replaceAll(' ', '_')}
              </Link>
            </li>
          )
        })}
      </ol>
      <p className={isSafari ? "text-gray-safari2" : 'text-gray'}>{"<>"}</p>
    </div>
  )
};

export default ListProject;